<i18n locale="en">
{
  "title": "Upcoming events near you",
  "actions": {
    "see-more": "See More Items"
  },
  "empty": {
    "header": "There are no events right now",
    "sub": "Check back later to see if we’ve added any"
  }
}
</i18n>

<template>
  <PreviewSheet border="primary" radius="0">
    <div class="event-calendar-preview flex-col">
      <div
        v-if="currentResource?.path?.params?.page !== 'events'"
        class="align-end flex-row justify-between"
      >
        <div class="flex-col gap-8">
          <PreviewDecorationLine />
          <PreviewTypographyLegacy :text="t('title')" variant="heading2" />
        </div>
      </div>
      <div
        v-if="events.length > 0"
        class="event-calendar-preview__items flex-row gap-6"
      >
        <EventCardPreview
          v-for="event in events"
          :key="event.id"
          :event="event"
        />
      </div>
      <PreviewSheet
        v-else
        background="secondary"
        class="event-calendar-preview__empty"
      >
        <div class="align-center h-full flex-col justify-center gap-2">
          <PreviewTypographyLegacy
            :text="t('empty.header')"
            variant="heading4"
          />
          <PreviewTypographyLegacy
            :text="t('empty.sub')"
            variant="paragraphRegular"
          />
        </div>
      </PreviewSheet>
    </div>
  </PreviewSheet>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import { useActiveBrand, useApplicationScope } from '@/core/store'
import PreviewTypographyLegacy from '@/lib/builder/public/preview/legacy/PreviewTypographyLegacy.vue'
import PreviewDecorationLine from '@/lib/builder/public/preview/PreviewDecorationLine.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import { logError } from '@/logger'
import { OlympusClient } from '@/OlympusClient'

import EventCardPreview from './EventCardPreview.vue'

export default {
  name: 'EventCalendarPreviewLegacy',
  components: {
    EventCardPreview,
    PreviewDecorationLine,
    PreviewSheet,
    PreviewTypographyLegacy,
  },
  props: {
    /** Section */
    id: { type: String, required: true },
  },
  setup() {
    const { t } = useI18n()
    const { activeBrandId } = useApplicationScope()
    const { locations } = useActiveBrand()

    return { activeBrandId, locations, t }
  },
  data() {
    return {
      events: [],
    }
  },
  computed: {
    ...mapGetters({
      currentResource: 'websiteBuilder/currentResource',
    }),
  },
  created() {
    this.loadEvents()
  },
  methods: {
    async loadEvents() {
      const { activeBrandId } = this
      try {
        const response = await OlympusClient.events.v1.getEvents({
          query: {
            brandId: activeBrandId,
            limit: 3,
            page: 1,
          },
        })

        this.events = response.results
      } catch (error) {
        logError(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.event-calendar-preview {
  padding: 32px 80px;
  gap: 40px;

  &__items {
    overflow: hidden;
  }

  &__empty {
    height: 384px;
  }
}
</style>
